export default "__VITE_ASSET__Dj8A77Wf__"